import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ContactSection = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) return setError("Name is required");
    if (!/^\d{10}$/.test(formData.phone))
      return setError("Enter valid 10 digit mobile number");

    try {
      setLoading(true);
      setError("");

      const googleData = new FormData();
      googleData.append("Name", formData.name);
      googleData.append("Phone", formData.phone);

      const crmData = {
        name: formData.name,
        phone: formData.phone,
        listId: "6981908ef6638ecf19d8cec7",
        redirect: "",
      };

      const [googleRes, crmRes] = await Promise.all([
        fetch(
          "https://script.google.com/macros/s/AKfycbyvfEaLbk80-Mtfcixo8jFB05hvTh8k4wMB64ehSmPrdzeQY9oWgpYSo9LmAc4LPQv-/exec",
          {
            method: "POST",
            body: googleData,
          }
        ),
        fetch(
          "https://enterprise.godial.cc/meta/api/externals/contact/add?access_token=nLWC3eZkuDXNbcElB7wXENJZCMM15hmG7GnDJKs6Zdcxqbh4AHq7o24nAiD43K0e",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(crmData),
          }
        ),
      ]);

      if (!googleRes.ok || !crmRes.ok) throw new Error("Submission failed");

      setFormData({ name: "", phone: "" });
      navigate("/thank-you");

    } catch (err) {
      console.error("Lead submit error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="w-full bg-white">
      <div className="max-w-7xl mx-auto shadow-lg rounded-xl overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          {/* IMAGE */}
          <div className="w-full lg:w-1/2 order-1 sm:order-1 md:order-2 lg:order-2">
            <img
              src="/Images/BANNER/1.jpg"
              alt="Godrej project in Kharghar"
              className="w-full object-cover 
               h-[240px] sm:h-[280px] 
               md:h-[320px] 
               lg:h-full"
            />
          </div>

          {/* FORM */}
          <div className="w-full lg:w-1/2 p-6 sm:p-8 order-2 sm:order-2 md:order-1 lg:order-1">
            <h2 className="text-2xl text-center font-semibold text-[#6d8f0d] mb-6 lg:text-left">
              Schedule a Site Visit
            </h2>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name*"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md px-4 py-3 focus:ring-2 focus:ring-[#6d8f0d] outline-none"
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md px-4 py-3 focus:ring-2 focus:ring-[#6d8f0d] outline-none"
              />

              {error && (
                <p className="text-red-500 text-sm text-center">{error}</p>
              )}

              <div className="flex items-start gap-2 text-xs text-gray-600">
                <input type="checkbox" className="mt-1" defaultChecked />
                <p>
                  I consent to the processing of provided data according to{" "}
                  <span
                    className="text-[#6d8f0d] underline cursor-pointer"
                    onClick={() => {
                      navigate("/policy");
                      window.scrollTo(0, 0);
                    }}
                  >
                    Privacy Policy
                  </span>{" "}
                  | Terms & Conditions.
                </p>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#7f9f1a] hover:bg-[#6c8914] text-white py-3 rounded-lg transition disabled:opacity-60"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;